(function () {
	angular
		.module('trackeye')
		.factory('LanguageService', LanguageService);

	LanguageService.$inject = ['C4ApiService', 'AppFactory', '$translate', '$localStorage'];

	function LanguageService(api, AppFactory, $translate, $localStorage) {
		var exports = {},
			options = {
				locales: {
					default: AppFactory.getDefaultLocale(),
					app: AppFactory.getAppLocales(),
					backend: AppFactory.getBackendLocales()
				}
			},
			default_lang = 'en',
			languages = ['da', 'en', 'de', 'fr', 'es', 'lt', 'lv', 'pt', 'nl']; // This should be fetched from backend

		/**
		 * Returns an array of the supported languages
		 * @returns {string[]}
		 */
		exports.getLanguages = function () {
			return languages;
		};

		/**
		 * Returns the default language, based on the navigator
		 * @returns {string}
		 */
		exports.getDefaultLanguage = function () {
			var navigator_lang = getNavigatorLanguage(true);

			if (exports.hasLanguage(navigator_lang))
				return navigator_lang;

			return default_lang;
		};

		exports.getCurrentLanguage = function () {
			return $translate.use();
		}

		/**
		 * Asserts if the application has a given language
		 * @param {string} lang - format: da/da_DK/da-DK
		 * @returns {boolean}
		 */
		exports.hasLanguage = function (lang) {
			return !!options.locales.app.filter(function(app_locale) {
				lang = lang.split(/[-_]/)[0];
				return app_locale.indexOf(lang) >= 0;
			}).length;
		};

		/**
		 * Sets the application language
		 * @param {string} lang - format: da/en/de
		 * @returns {boolean}
		 */
		exports.setLanguage = function (lang) {
			if (exports.hasLanguage(lang)) {
				$localStorage.language = lang
				moment.locale(lang);
				$translate.use(lang);
				return true;
			}

			$translate.use(exports.getDefaultLanguage());
			moment.locale(exports.getDefaultLanguage());
			$localStorage.language = exports.getDefaultLanguage()
			return false;
		};

		exports.setDefaultLanguage = function () {
			return exports.setLanguage($localStorage.language || exports.getDefaultLanguage());
		};


		/**
		 * Asserts if the application is using given language
		 * @param {string} lang - format: da/da_DK/da-DK
		 * @returns {boolean}
		 */
		exports.isAppUsingLanguage = function (lang) {
			var app_lang = $translate.use();
			lang = lang.split(/[-_]/)[0];

			return lang === app_lang;
		};

		/**
		 * Returns the current active language, as a locale string
		 * @returns {string} format da_DK
		 */
		exports.getAppLocaleString = function () {
			return options.locales.app.filter(function(app_locale) {
				return app_locale.indexOf($translate.use()) >= 0;
			}).pop();
		};

		exports.getLocaleFromLang = function (lang) {
			return options.locales.app.filter(function(app_locale) {
				return app_locale.indexOf(lang) >= 0;
			}).pop();
		};

		function getNavigatorLanguage(language_only) {
			var lang = navigator.language || navigator.browserLanguage;
			lang = lang.replace("-","_");

			if (!language_only)
				return lang;

			return lang.split("_")[0];
		}

		return exports;
	}
})();